export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-AR').format(price);
};

export const getMinPrice = (blisters) => {
  if (blisters && blisters.length > 0) {
    return Math.min(...blisters.map(blister => parseFloat(blister.price)));
  }
  return 0;
};

export const getMaxPrice = (blisters) => {
  if (blisters && blisters.length > 0) {
    return Math.max(...blisters.map(blister => parseFloat(blister.price)));
  }
  return 0;
};